module.exports = __webpack_public_path__ + "img/status-delivered.007f22a3.svg";